const TrackCategorizationDropdown = function (element) {
  if (!element || element.nodeType !== 1) return;
  this.dropdownContainer = element;
  this.switchCounter = element.querySelector('.checkbox-dropdown__switch-counter');
  this.originalSwitchLabel = this.switchCounter ? this.switchCounter.getAttribute('data-checkbox-dropdown-label') : '';
  this._init();
};

TrackCategorizationDropdown.prototype._init = function () {
  if (!this.switchCounter) return;

  this._updateSwitchLabel();

  const checkboxesContainer = this.dropdownContainer.querySelector('.checkbox-dropdown__checkboxes');
  if (!checkboxesContainer) return;

  checkboxesContainer.addEventListener('change', this._updateSwitchLabel.bind(this));
  checkboxesContainer.addEventListener('click', this._updateSwitchLabel.bind(this));
};

TrackCategorizationDropdown.prototype._updateSwitchLabel = function () {
  const activeElements = this.dropdownContainer.querySelectorAll('input[type=checkbox]:checked');

  if (activeElements.length === 0) {
    this.switchCounter.textContent = this.originalSwitchLabel || '';
    this.switchCounter.removeAttribute('title');
    return;
  }

  const labels = Array.from(activeElements).map(function (input) {
    const labelNode = input.closest('label');
    return labelNode ? labelNode.textContent.trim() : '';
  }).filter(function (text) { return text.length > 0; });

  const labelText = labels.join(', ');
  this.switchCounter.textContent = labelText;
  this.switchCounter.setAttribute('title', labelText);
};

export default TrackCategorizationDropdown;
